export const LOCAL_TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone; 